import { BI_API_HOST, TASKS_API_HOST } from '~/common/utils/api-hosts.js';

const BASE_URL = BI_API_HOST;

export default {
  bi_schema: {
    url: 'schema',
    baseURL: BASE_URL,
    methods: {
      table: req => ({
        url: `schema/${req.id}/tables`,
        ...(req.query && { params: req.query }),
        ...(req.headers && { headers: req.headers }),
        method: 'GET',
      }),
      columns: req => ({
        url: `schema/${req.id}/tables/${req.table_name}/columns`,
        ...(req.query && { params: req.query }),
        ...(req.headers && { headers: req.headers }),
        method: 'GET',
      }),
      column_values: req => ({
        url: `schema/${req.id}/tables/${req.table_name}/columns/${req.column_name}/values`,
        ...(req.query && { params: req.query }),
        ...(req.headers && { headers: req.headers }),
        method: 'GET',
      }),
    },
  },
  bi_query: {
    url: 'queries',
    baseURL: BASE_URL,
    methods: {
      execute: req => ({
        url: `queries/${req.id}/execute`,
        ...(req.query && { params: req.query }),
        ...(req.headers && { headers: req.headers }),
        data: req.body,
        method: 'POST',
      }),
    },
  },
  bi_dashboard: {
    url: 'reports/bi',
    baseURL: TASKS_API_HOST,
    methods: {
      get_dashboard: req => ({
        url: `reports/${req.id}/bi`,
        ...(req.query && { params: req.query }),
        ...(req.headers && { headers: req.headers }),
        data: req.body,
        method: 'GET',
      }),
      patch_dashboard: req => ({
        url: `reports/${req.id}/bi`,
        ...(req.query && { params: req.query }),
        ...(req.headers && { headers: req.headers }),
        data: req.body,
        method: 'PATCH',
      }),
      create_share_link: req => ({
        url: `reports/bi/${req.id}/share-link`,
        ...(req.query && { params: req.query }),
        data: req.body,
        method: 'POST',
      }),
      revoke_share_link: req => ({
        url: `reports/bi/${req.id}/share-link`,
        ...(req.query && { params: req.query }),
        method: 'DELETE',
      }),
      get_token: req => ({
        url: `reports/${req.id}/bi`,
        data: req.body,
        method: 'POST',
        // Skip JWT auth header; pass organization explicitly so the interceptor doesn't override it
        params: { token: false, organization: req.query?.organization },
      }),
      get_public_dashboard: req => ({
        url: `public/dashboards/${req.token}`,
        ...(req.query && { params: req.query }),
        method: 'GET',
      }),
    },
  },
};
